import { Button, DatePicker, Form, Input, message, Select, Tabs, TabsProps } from 'antd';
import {
  FilterPayload,
  getOverdueList,
  getSelectList,
  OverdueXLList,
  SelectPayload,
  SelectResponse,
} from 'api/dashboard';
import { useCallback, useEffect, useState } from 'react';

import { FileExcelFilled } from '@ant-design/icons';
import xlsx from 'json-as-xlsx';
import OverdueListPage from '../OverdueList';
const dateFormat = 'DD/MM/YYYY';

type Props = {
  isLoading: boolean;
  onSubmit: (values: FilterPayload) => Promise<void>;
};
const filterPayload: FilterPayload = { type: 3 };
const initSelectResp: SelectResponse = {
  data: [],
};

// const initPartners: SelectList[] = [];

const Filter = ({ onSubmit }: Props) => {
  const { Option } = Select;
  const [form] = Form.useForm<FilterPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const [isOpen, setOpen] = useState(false);
  const [sources, setSource] = useState(initSelectResp);
  const [statuses, setStatus] = useState(initSelectResp);
  const [selectedTab, setSelectedTab] = useState(3);

  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    const partnerPayload: SelectPayload = {
      SKey: 'Source',
    };

    if (isAdmin == 'true') {
      getSelectList(partnerPayload).then((res) => {
        // setPagedList(res);
        //   setIsLoading(true);
        setSource(res);
      });
    }

    const statusPayload: SelectPayload = {
      SKey: 'StatusSource',
    };
    getSelectList(statusPayload).then((res) => {
      setStatus(res);
    });
    // setIsLoading(false);
  }, []);

  const handleSubmit = useCallback(
    async (values: FilterPayload) => {
      let updatedValues = { ...values };
      updatedValues.Username = sessionStorage.getItem('user')?.toString();
      updatedValues.type = selectedTab;
      if (isAdmin != 'true') {
        updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      }
      setFilter(updatedValues);
      // form.resetFields();
    },
    [onSubmit, form, filter]
  );

  function handleDownload(_e: any) {
    filter.IsExtract = true;
    // getPaymentReport(filter).then((_x) => {
    //   // download(_x.data.data);
    // });

    getOverdueList(filter).then((_x) => {
      if (_x.data.data != null) {
        let settings = {
          fileName: 'OverdueReport', // Name of the resulting spreadsheet
          extraLength: 3, // A bigger number means that columns will be wider
          writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
          writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
          RTL: false, // Display the columns from right-to-left (the default value is false)
        };

        _x.data.data.forEach((element, index) => {
          element.key = index + 1;
        });

        const xlData: OverdueXLList[] = _x.data.data;

        let data = [
          {
            sheet: 'Sheet 1',
            columns: [
              { label: 'Sr. No.', value: 'key' },
              { label: 'LoanNumber', value: 'LoanNumber' },
              { label: 'EmiSiPiAmt', value: 'EmiSiPiAmt' },
              { label: 'CurrMonthInst', value: 'CurrMonthInst' },
              { label: 'BounceCharge', value: 'BounceCharge' },
              { label: 'PenalCharge', value: 'PenalCharge' },
              { label: 'TotalAmount', value: 'TotalAmount' },
              { label: 'AllowedAmount', value: 'AllowedAmount' },
              { label: 'LastLinkCreated', value: 'LastLinkCreated' },
              { label: 'LastLinkStatus', value: 'LastLinkStatus' },
              { label: 'TotalCount', value: 'TotalCount' },
              { label: 'CustomerName', value: 'CustomerName' },
              { label: 'MobileNumber', value: 'MobileNumber' },
              { label: 'EmailId', value: 'EmailId' },
              { label: 'LoanBranch', value: 'LoanBranch' },
              { label: 'LoanType', value: 'LoanType' },
              { label: 'CIFId', value: 'CIFId' },
              { label: 'ApplicantType', value: 'ApplicantType' },
            ],
            content: xlData,
          },
        ];
        xlsx(data, settings);
      } else {
        message.warn('No Data Found!');
      }
    });
  }

  // function handleDate(_e: any) {
  //   filter.PaymentDateFrom = moment(_e, 'DD/MM/YYYY').toString();
  // }

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    filterPayload.type = filter.type;
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
  }

  function filterClicked(_r: any) {
    const toggle: boolean = isOpen;

    if (toggle) setOpen(false);
    else setOpen(true);
  }

  const handleTabChange = (e: any) => {
    debugger;
    setSelectedTab(e);
    let updatedFilter = { ...filter };

    updatedFilter.type = e;
    updatedFilter.IsExtract = false;
    setFilter(updatedFilter);
  };
  const cardList: TabsProps['items'] = [
    {
      key: '3',
      label: `Overdue Not triggered records`,
    },
    {
      key: '1',
      label: `Above 10 lac `,
    },
    {
      key: '2',
      label: `Active Records`,
    },
  ];

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Overdue Dashboard</h2>
              <Tabs
                defaultActiveKey={selectedTab.toString()}
                centered
                type="card"
                items={cardList}
                onChange={handleTabChange}
              />
              <Button
                shape="circle"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                  >
                    <path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path>
                  </svg>
                }
                onClick={filterClicked}
                style={{ float: 'right', margin: 10, zIndex: 1000, border: 0 }}
              />
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                {isOpen ? (
                  <Form<FilterPayload>
                    form={form}
                    onFinish={handleSubmit}
                    layout="vertical"
                    scrollToFirstError
                    className="standard-forms"
                    initialValues={{
                      ['Username']: sessionStorage.getItem('user')?.toString(),
                      ['SourceApplicationName']:
                        isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
                    }}
                  >
                    <div>
                      <div className="row">
                        <div className="col-xs-12 col-sm-4 col-md-4">
                          <div className="input-box">
                            <Form.Item
                              label={'Loan Number :'}
                              name="LoanNumber"
                              className="fieldTitle"
                            >
                              <Input placeholder={'Loan Number'} />
                            </Form.Item>
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4">
                          <div className="input-box">
                            <Form.Item label={'From:'} name="FromDate" className="fieldTitle">
                              <DatePicker format={dateFormat} />
                              {/* <DatePicker format={'DD/MM/YYYY'} onSelect={handleDate} /> */}
                            </Form.Item>
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4">
                          <div className="input-box">
                            <Form.Item label={'To :'} name="ToDate" className="fieldTitle">
                              <DatePicker format={dateFormat} />
                              {/* <DatePicker format={'DD-MM-YYYY'} onSelect={handleDate} /> */}
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xs-12 col-sm-4 col-md-4">
                          <div className="input-box">
                            {isAdmin == 'true' ? (
                              <Form.Item
                                label={'Source Application Name :'}
                                name="SourceApplicationName"
                                className="fieldTitle"
                              // rules={required}
                              // initialValue="Select"
                              >
                                <Select size="large" placeholder="Select">
                                  {/* <Option value="0">Select</Option> */}
                                  {sources.data.map((role) => (
                                    <>
                                      <Option value={role.SValue}>{role.SText}</Option>
                                    </>
                                  ))}
                                </Select>
                              </Form.Item>
                            ) : (
                              <Form.Item
                                label={'Source Application Name :'}
                                name="SourceApplicationName"
                                className="fieldTitle"
                              >
                                <Input
                                  disabled={true}
                                  style={{
                                    border: '1px solid #dcdcdc',
                                    borderRadius: '4px',
                                    fontWeight: '600',
                                    background: '#fafbfa',
                                    opacity: 0.5,
                                  }}
                                />
                              </Form.Item>
                            )}
                          </div>
                        </div>
                        {/* {selectedTab.toString() == '3' ? ( */}
                        <div className="col-xs-12 col-sm-4 col-md-4">
                          <div className="input-box">
                            <Form.Item
                              label={'Request Status :'}
                              name="Status"
                              className="fieldTitle"
                            // rules={required}
                            >
                              <Select size="large" placeholder="Select">
                                {statuses.data.map((status) => (
                                  <>
                                    <Option value={status.SValue}>{status.SText}</Option>
                                  </>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                        {/* ) : null} */}

                        <div className="col-xs-12 col-sm-4 col-md-4">
                          <div className="input-box">
                            <div style={{ marginTop: '42px', float: 'left' }}>
                              <Button
                                type="link"
                                icon={<FileExcelFilled />}
                                style={{ float: 'right', fontSize: '30px', color: 'green' }}
                                onClick={handleDownload}
                              ></Button>
                              &nbsp; &nbsp;
                              <Button
                                type="primary"
                                onClick={handleReset}
                                style={{ float: 'right', marginRight: '5px' }}
                              >
                                {'CLEAR'}
                              </Button>
                              &nbsp; &nbsp;
                              <Button
                                type="primary"
                                htmlType="submit"
                                style={{ float: 'right', marginRight: '10px' }}
                              >
                                {'SEARCH'}
                              </Button>
                              &nbsp; &nbsp;
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                ) : null}
              </div>

              <OverdueListPage filter={filter} onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
